export const congNo = {
  title: '应收/欠款',
  titles: {
    list: '应收汇总报表',
    customers: '客户应收',
    invoices: '按单据应收',
    invoiceLines: '按单据欠款明细',
    payments: '付款',
    refunds: '退款',
    detail: '客户应收明细',
  },
  fields: {
    invoiceCode: '发票编号',
    productCode: '商品编号',
    productName: '商品名称',
    unit: '单位',
    quantity: '数量',
    unitPrice: '单价',
    lineDiscount: '折扣',
    lineAmount: '金额',
    orderDiscount: '整单折扣',
    otherIncome: '其他收入',
    tax: '税',
    debtAmount: '欠款',
    voucherCode: '单据编号',
    voucherType: '单据类型',
    customerCode: '客户代码',
    maNhanVienPhuTrach: '负责业务员',
    customerName: '客户',
    supplierCode: '供应商代码',
    supplierName: '供应商',
    totalReceivable: '应收',
    openingDebt: '期初欠款',
    invoiceReceivable: '发票应收',
    invoicePaid: '发票已收',
    totalPaid: '已收',
    totalOtherCost: '其他费用',
    totalDeduction: '扣减',
    totalOpeningAdjust: '余额调整 + 期初应收',
    totalTaxAdvance: '代垫税金',
    totalRefund: '退款',
    totalSalesReturn: '退货',
    balance: '未收',
    balancePayable: '应付',
    phone: '电话',
    branch: '门店',
    time: '时间',
    paymentMethod: '付款方式',
    amount: '金额',
    note: '备注',
    returnCode: '退货单号',
    refundDue: '应退客户',
    refundPaid: '已退客户',
    refundRemain: '尚需退',
    actions: '操作',
    dinhMucCongNo: '信用额度',
    ngayCanDoiNo: '催收日期',
    canhBaoCongNo: '催收提醒',
  },
  canhBao: {
    vuotDinhMuc: '超出额度',
    quaHan: '逾期 {count} 天',
    sapDenHan: '剩 {count} 天',
    trongHan: '账期内',
    denHanHomNay: '今日到期',
  },
  hanDoiNo: {
    hangThang: '每月{day}日',
    kyNay: '本期到期：{date}',
  },
  list: {
    rowClickExpand: '单击行显示或隐藏应收明细',
  },
  tabs: {
    customers: '应收客户',
    invoices: '应收按单',
    invoiceLines: '应收明细',
    payments: '交易付款',
    refunds: '交易退款',
  },
  actions: {
    viewDetail: '查看详情',
    viewReturn: '查看退货单',
    detail: '详情',
    exportExcel: '导出 Excel',
    exportAllSheets: '导出全部',
    exportAllSheetsHint: '导出全部 5 个工作表：汇总、发票、收款、退款、结账记录',
    chot: '结账',
    paymentTerms: '付款条款',
    chotHistory: '结账记录',
    lock: '锁定',
    unlock: '解锁',
  },
  filter: {
    searchPlaceholder: '按客户名称或代码搜索',
    searchPlaceholderDon: '按单据或客户代码搜索',
    searchPlaceholderDonChiTiet: '按单据、客户、商品代码或名称搜索',
    searchPlaceholderPayment: '按客户代码、名称或备注搜索',
    searchPlaceholderRefund: '按客户代码、名称或备注搜索',
    fromDate: '开始日期',
    toDate: '结束日期',
    textDetailTitle: '详细筛选',
  },
  filters: {
    hintSection: '提示',
    hintBody: '使用搜索按客户名称或代码筛选。',
    all: '全部',
    dateSection: '时间',
    dateRangePlaceholder: '选择日期范围',
    fromDate: '开始日期',
    toDate: '结束日期',
    debtSection: '应收状态',
    debtAll: '全部',
    debtOutstanding: '有欠款（≠ 0）',
    debtCleared: '已结清（= 0）',
    canhBaoSection: '催收提醒',
    canhBaoCanDoi: '需催收（超额度或到期）',
    canhBaoVuotDinhMuc: '超出信用额度',
    canhBaoQuaHan: '逾期',
    customerTypeSection: '客户类型',
    groupSection: '客户组',
    voucherTypeInvoice: '发票',
    voucherTypeReturn: '退货',
    debtRangeSection: '欠款范围',
    debtFrom: '从',
    debtTo: '到',
    transactionTypeSection: '交易类型',
    lockSection: '锁定状态',
    locked: '已锁定',
    unlocked: '未锁定',
    sortSection: '排序',
    sortField: '排序字段',
    sortDir: '排序方向',
    nhanVienPhuTrachPlaceholder: '按姓名或员工编码搜索',
  },
  loai: {
    caNhan: '个人',
    congTy: '组织/个体户',
  },
  sort: {
    maKhachHang: '客户代码',
    tenKhachHang: '客户名称',
    maHoaDon: '发票编号',
    maPhieuTraHang: '退货单号',
    soTien: '金额',
    thoiGian: '时间',
    maNhaCungCap: '供应商代码',
    tenNhaCungCap: '供应商名称',
    conNo: '欠款',
  },
  aria: {
    columnPicker: '选择显示列',
  },
  detail: {
    invoiceReturn: '退货',
    invoiceRemaining: '发票余额',
    openingBalance: '期初余额',
    closingBalance: '期末余额',
    tabSummary: '汇总',
    tabReceivable: '发票',
    tabPayment: '付款',
    tabTransaction: '往来',
    tabRefund: '退款',
    tabChotHistory: '结账记录',
    rowKindInvoice: '发票',
    rowKindPayment: '付款',
    rowKindRefund: '退款',
    rowKindTransaction: '往来',
    openingAdjust: '调整+期初',
    receivingAccount: '收款账户',
    otherCost: '其他费用',
    deduction: '扣减',
    paid: '已付',
    taxAdvance: '代垫税金',
    paymentImages: '收款图片',
    refundImages: '退款图片',
    congVaoCongNo: '增加欠款',
    truDiCongNo: '减少欠款',
    notFound: '未找到客户。',
    loadError: '无法加载应收明细。',
    filterInvoiceSearch: '搜索发票编号',
    filterBranchAll: '全部门店',
    filterClear: '清除筛选',
  },
  transaction: {
    overpayTitle: '金额超出欠款',
    overpayConfirm: '金额 {soTien} 大于剩余欠款 {conNo}。交易后客户余额将为负（多付）。仍要保存吗？',
    add: '新增记录',
    create: '创建应收记录',
    edit: '编辑记录',
    date: '交易日期时间',
    type: '类型',
    amount: '金额',
    phanBo: {
      title: '分配到发票',
      hint: '默认从最旧到最新自动分配。勾选锁定或改金额可固定该单；剩余继续自动分配。',
      empty: '没有可分配的未结发票。',
      loadFailed: '无法加载未结发票。',
      lock: '锁定',
      tongPhanBo: '已分配',
      conLai: '未分配',
    },
    description: '说明',
    runningBalance: '交易后余额',
    deductionCategory: '扣减原因',
    images: '附件',
    deleteConfirm: '删除这条应收记录？',
    sections: {
      images: '收款图片',
      refundImages: '客户退款图片',
    },
    canHoanTienChoKhach: '需要向客户退款',
    soTienNhan: '实收金额',
    soTienThuHo: '代收金额',
    thuHoCho: '代收对象',
    soTienCanHoan: '应退金额',
    congTyNhanTien: '收款账户',
    congTyNhanTienPlaceholder: '选择公司资金/银行账户',
    congTyNhanTienHint: '选择资金账户后将自动生成收款单（类型：交易付款）',
    congTyChuyenTien: '付款公司',
    soTienCanHoanHint: '自动计算：收款 − 付款 − 代收',
    ghiChuHoanTien: '退款备注',
    refundStatus: '退款状态',
    refundPartial: '部分退款',
    refundDone: '已退款',
    refundStatuses: {
      CHUA_HOAN: '未退款',
      HOAN_MOT_PHAN: '部分退款',
      DA_HOAN: '已退款',
    },
    taiKhoanChiHoanTien: '退款出纳账户',
    taiKhoanChiHoanTienPlaceholder: '选择扣款账户',
    taiKhoanChiHoanTienHint: '必填 — 自动创建已审批的付款单并立即扣款',
    types: {
      THANH_TOAN: '收款',
      HOAN_TIEN: '退款',
      CHI_PHI_KHAC: '其他费用',
      KHAU_TRU: '扣减',
      TAM_UNG_THUE: '预缴税',
      CAN_BANG: '余额调整',
      KHOI_TAO: '期初欠款',
    },
    signedAmountHint: '正数增加欠款，负数减少欠款，不能为 0。',
    deductionCategories: {
      GIAM_GIA: '折扣',
      HANG_LOI: '残次/损坏',
      SAI_GIA: '价格错误',
      KHAC: '其他',
    },
    imagesUpload: {
      pickImage: '选择图片',
      pasteImage: '粘贴图片',
      uploading: '正在上传...',
      uploadError: '上传失败',
      pasteImageNoImage: '剪贴板没有图片。',
      dragDropHint: '拖放图片到此处或点击选择',
    },
  },
  importKhoiTao: {
    perCustomerHint:
      '仅当期初日期早于该客户所有发票、退货和往来时才可录入。正数增加欠款，负数减少欠款。',
    sampleCode: '客户编码',
    open: '导入期初',
    title: '导入期初欠款',
    description: 'Excel 两列：客户编码、金额（正数增加欠款，负数减少欠款）。金额为整数（VND）。所有行共用一个日期。',
    date: '期初日期时间',
    colCustomerCode: '客户编码',
    colAmount: '金额',
    templateFileName: '期初欠款导入模板.xlsx',
    noSheet: 'Excel 文件中没有工作表。',
    noData: 'Excel 文件没有有效数据行。',
    readError: '无法读取 Excel 文件。',
    invalidSummary: '{count} 行无效。请修改文件后重新选择。',
    errMissingCode: '缺少客户编码',
    errMissingAmount: '缺少金额',
    errInvalidAmount: '金额无效：{raw}',
    errZeroAmount: '金额不能为 0',
    errFractionalAmount: '金额必须为整数（VND），不能有小数：{raw}',
    errDuplicate: '文件中客户编码重复',
    hint: '日期必须早于已有发票、退货和往来。正数增加欠款，负数减少欠款。',
    submit: '导入',
    empty: '没有有效行。',
  },
  chotAll: {
    open: '全部结账',
    title: '为全部客户结账',
    hint: '对所有在用客户结到所选日期结束。已结期间将锁定发票、退货和欠款往来。',
    submit: '全部结账',
    confirm: '为所有在用客户结账至 {date} 结束？结账后期间内的发票、退货和欠款往来将被锁定。',
    resultSummary: '已结账 {ok}/{total} 位客户。{fail} 位客户结账失败：',
  },
  chot: {
    title: '结账',
    note: '备注',
    submit: '确认结账',
    closeDate: '结账日期',
    snapshotHint: '显示为当前往来余额。结账期间自上次结账之后起至结账日期结束；金额由系统自动计算。',
    confirm: '确认将该客户的往来账结算至 {date}？结账后，期间内的发票、退货单和交易将被锁定。',
  },
  chotHistory: {
    title: '结账历史',
    closedAt: '结账时间',
    period: '期间',
    note: '备注',
    cancelled: '已撤销',
  },
  paymentTerms: {
    title: '更新付款期限',
    days: '付款天数',
  },
  messages: {
    noData: '暂无数据',
    loadError: '无法加载应收列表。',
    listSummary: '共 {count} 个客户',
    listSummaryDon: '共 {count} 张单据',
    listSummaryDonChiTiet: '共 {count} 行',
    listSummaryPayment: '共 {count} 笔往来',
    listSummaryRefund: '共 {count} 笔退款',
    noTransactions: '暂无流水',
    noChotHistory: '暂无结账记录',
    invalidType: '往来类型无效。',
    invalidDeductionCategory: '请选择扣减原因。',
    invalidAmount: '金额无效。',
    invalidDate: '请选择日期。',
    futureDate: '交易时间不能晚于当前时间。',
    futureCloseDate: '结账日期不能晚于今天。',
    amountMustBePositive: '金额必须大于 0。',
    refundFundRequired: '退款必须选择账户以创建付款单。',
    receivedAmountRequired: '请输入实收金额。',
    refundAmountRequired: '应退金额必须大于 0（实收 − 入账金额 − 代收）。',
    chotSuccess: '已结账。',
    chotAllSuccess: '已结账 {ok}/{total} 个客户。',
    huyChot: '撤销结账',
    huyChotConfirm: '撤销最近一次结账？上一结账日之后的单据可以再修改。',
    huyChotSuccess: '已撤销结账。',
    importSuccess: '期初导入：成功 {ok}，失败 {fail}。',
    lockSuccess: '已锁定记录。',
    lockConfirm: '锁定此往来？锁定后需解锁才能修改或删除。',
    unlockConfirm: '解锁此往来以允许修改 / 删除？',
    unlockSuccess: '已解锁记录。',
    lockedNeedUnlock: '记录已锁定，请先解锁再修改或删除。',
  },
}

